const State = {
  salesRegisterConfirmDialog: false,
  meta: {},
  summary: {},
  saleList: [],
  salePaymentList: [],
  rackNumberByProduct: [],
  saleDetail: [],
  bulkOperationCompleted: false
}

export default State
